export default {
  PARTNER_MANAGEMENT: 'partnerManagement',
  PRACRTICE_MANAGEMENT: 'practiceManagement',
};
